import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import MainQuiz from "../../components/quiz/MainQuiz";
import { fetchCompletedQuizById } from "../../redux/actions/quizzesActionCreators";

const CompleteQuiz = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.quizzes.selected);
  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser)?.account_type;
  const orgaId = useSelector((state) => state.organizationProfile.id);
  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    if (accountType === "enterprise") {
      if (orgaId) {
        dispatch(
          fetchCompletedQuizById(params.quizId, history, accountType, orgaId)
        );
      }
    } else {
      dispatch(fetchCompletedQuizById(params.quizId, history));
    }
  }, [dispatch, params.quizId, accountType, orgaId]);

  return (
    <>
      {data ? (
        <MainQuiz
          is_completed
          data={data}
          initialPayload={data?.answers?.questions}
          initialThreshold={data?.answers?.usecases}
        />
      ) : null}
    </>
  );
};

export default CompleteQuiz;
